import { Components, Theme } from "@mui/material";

export const ACCORDION_SUMMARY_THEME: Components<Theme>["MuiAccordionSummary"] =
  {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        // fix default use of spacing() in MUI's base style
        padding: theme.spacing(0, 16),
      }),
    },
  };

export const ACCORDION_DETAILS_THEME: Components<Theme>["MuiAccordionDetails"] =
  {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        // fix default use of spacing() in MUI's base style
        padding: theme.spacing(8, 16, 16),
      }),
    },
  };
